<script lang="ts">
    export let toggleFunction;
    export let active;
</script>

<span class:active on:click={toggleFunction}>
    <h1 class:active>V</h1>
    <h2><slot /></h2>
</span>

<style>
    h1,
    h2 {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
        width: fit-content;
        line-height: 1.5rem;
        font-family: "PoisonHope";
    }

    h1 {
        margin-right: 8px;
        transition: linear transform 0.1s;
        transform: rotate(-90deg);
    }
    h1.active {
        transition: linear transform 0.1s;
        transform: rotate(0deg);
    }
    span:active {
        color: #5d0610;
    }
    span.active {
        color: #9c0719;
    }
    span:hover {
        cursor: pointer;
        color: #5d0610;
    }
    span {
        display: flex;
        flex-direction: row;
        align-content: center;
        width: fit-content;
    }
</style>
